import { createApp } from "vue";
import router from "@/router";
import AppMain from "@/App.vue";

import { datadogLogs } from "@datadog/browser-logs";

import { IonicVue } from "@ionic/vue";

import Vue3Toastify from "vue3-toastify";

import "./main.css";
import "vue3-toastify/dist/index.css";

/* LOCALIZATION */
import { i18n } from "@/locales/i18n";

/* PINIA STORE */
import { createPinia } from "pinia";
import { registerSW } from "virtual:pwa-register";
import { PingService } from "@/services/ping.service";
import VueDOMPurifyHTML from "vue-dompurify-html";

const datadogEnvironment = import.meta.env.VITE_APP_ENVIRONMENT || import.meta.env.MODE;
const datadogClientToken = import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN;

initializeDatadogLogging(datadogEnvironment, datadogClientToken);

// auto update the pwa as soon as changes in the precache manifest are detected
const intervalMS = 60 * 1000;

registerSW({
    immediate: true,
    onRegistered(r) {
        if (r) {
            setInterval(() => {
                r.update();
            }, intervalMS);
        }
    },
});

const pinia = createPinia();

const app = createApp(AppMain).use(IonicVue).use(router).use(pinia).use(i18n);

app.use(Vue3Toastify, {
    autoClose: 3000,
    position: "top-center",
    transition: "slide",
    hideProgressBar: true,
});

app.use(VueDOMPurifyHTML);

router
    .isReady()
    .then(() => {
        app.mount("#app");
    })
    .then(() => {
        return PingService.getInstance().repeatingPing();
    });

document.addEventListener("visibilitychange", async () => {
    if (document.visibilityState === "visible") {
        await PingService.getInstance().repeatingPing();
    }
});

function initializeDatadogLogging(environment: string, clientToken: string | undefined): void {
    if (!clientToken) {
        console.warn("Datadog client token missing; skipping log initialization.");
        return;
    }

    datadogLogs.init({
        clientToken,
        site: "datadoghq.eu",
        forwardErrorsToLogs: true,
        env: environment,
        service: "timerecorder-pwa",
        version: import.meta.env.PACKAGE_VERSION,
    });

    if (environment === "staging" || environment === "production") {
        datadogLogs.logger.setHandler(["console", "http"]);
        return;
    }

    datadogLogs.logger.setHandler(["console"]);
}
